import React ,{Component} from 'react';

import 'antd/dist/antd.css';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import { Layout, Menu} from 'antd';


import {
  DesktopOutlined,
  PieChartOutlined,

  UserOutlined,

  BellOutlined  ,
  CalendarOutlined ,
  BarChartOutlined ,
  PlusCircleOutlined ,FormOutlined 
} from '@ant-design/icons';


import Dashboard from './Dashboard'
import Attendence from '../../components/student/Attendence/Attendence'
import WeeklyTimeTabel from '../../components/student/Timetabel/weeklyTimeTabel'
import MainMessages from '../../components/student/MyMessages/MainMessages'
import CourseWise from '../../components/student/AcademicSylabus/CourseWise'
import ProgramScheme from '../../components/student/ProgramScheme/ProgramScheme'
import MainFee from '../../components/student/FMS/student/mainFee'
import FeeReceipts from '../../components/student/FMS/student/FeeReceipts'
import PayFee from '../../components/student/FMS/student/payFee'
import LogRequest from '../../components/student/RMS/logRequest'
import ViewRequest from '../../components/student/RMS/viewRequest'
import SeatingPlan from '../../components/student/Examination/SeatingPlan/seatingPlan'
import ViewGrades from '../../components/student/Examination/Result/viewGrades/viewGrades'
import ViewMarks from '../../components/student/Examination/Result/ViewMarks/viewMarks'
import Login from '../../components/student/Login/Login'


const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;



export default class SidebarLeft extends Component {
  state = {
    collapsed: true,
  };

  onCollapse = collapsed => {
    console.log(collapsed);
    this.setState({ collapsed });
  };

  render() {
    return (
      <Router>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible collapsed={this.state.collapsed} onCollapse={this.onCollapse}>
         <center>
         <div className="logo" >
       
       
      
         </div>
         </center>
          <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
            <Menu.Item key="1" icon={<PieChartOutlined />}>
            <Link to="/" />   Dashboard
            </Menu.Item>
          <Menu.Item key="2" icon={<BellOutlined />}>
             Announcements
            </Menu.Item>
            <Menu.Item key="3" icon={<UserOutlined />}>
              Profile
            </Menu.Item>
            
           
            <SubMenu key="sub1" icon={<DesktopOutlined />} title="LMS">
              <Menu.Item key="4">Attendence   <Link to="/Attendence" /> </Menu.Item>
              <Menu.Item key="5">Timetable    <Link to="/WeeklyTimeTabel" /></Menu.Item>
              <Menu.Item key="6">Messages     <Link to="/MainMessages" /></Menu.Item>
              <Menu.Item key="7">Academic Syallabus    <Link to="/CourseWise" /> </Menu.Item>
              <Menu.Item key="8">Program Scheme        <Link to="/ProgramScheme" /></Menu.Item>
            </SubMenu>
            <SubMenu key="sub2" icon={<PlusCircleOutlined/>} title="FMS">
              <Menu.Item key="9">Fee status <Link to="/MainFee" /></Menu.Item>
              <Menu.Item key="10">Pay Fee   <Link to="/PayFee" /></Menu.Item>
              <Menu.Item key="11">Pay Recepets <Link to="/FeeReceipts" /></Menu.Item>
            </SubMenu>
            <SubMenu key="sub3" icon={<FormOutlined />} title="RMS">
              <Menu.Item key="12">Log Request<Link to="/LogRequest" /></Menu.Item>
              <Menu.Item key="13">View Status<Link to="/ViewRequest" /></Menu.Item>
            </SubMenu>
            <SubMenu key="sub4" icon={<CalendarOutlined/>} title="Examantion">
              <Menu.Item key="14">Seating Plan<Link to="/SeatingPlan" /></Menu.Item>
              {/* <Menu.Item key="16">Registeration<Link to="/SeatingPlan" /></Menu.Item> */}
            </SubMenu>
            <SubMenu key="sub5" icon={<BarChartOutlined />} title="Results">
              <Menu.Item key="17">View Grades <Link to="/ViewGrades" /></Menu.Item>
              <Menu.Item key="18">View Marks <Link to="/ViewMarks" /></Menu.Item>
            </SubMenu>
     
          
          
          </Menu>
        </Sider>
        <Layout className="site-layout">
          <Header className="site-layout-background" style={{ padding: 0 }} />
          <Content style={{ margin: '5px 16px' ,padding:'10px',background : "white"}} className="text-center">
                
                            
                            <Route exact path="/" component={Dashboard} />
                            <Route  path="/Attendence" component={Attendence} />
                            <Route  path="/WeeklyTimeTabel" component={WeeklyTimeTabel} />
                            <Route  path="/MainMessages" component={MainMessages} />
                            <Route  path="/CourseWise" component={CourseWise} />
                            <Route  path="/ProgramScheme" component={ProgramScheme} />
                            <Route  path="/MainFee" component={MainFee} />
                            <Route  path="/FeeReceipts" component={FeeReceipts} />
                            <Route  path="/PayFee" component={PayFee} />
                            <Route  path="/LogRequest" component={LogRequest} />
                            <Route  path="/ViewRequest" component={ViewRequest} />
                            <Route  path="/SeatingPlan" component={SeatingPlan} />
                            <Route  path="/ViewGrades" component={ViewGrades} />
                            <Route  path="/ViewMarks" component={ViewMarks} />
                            <Route  path="/Login" component={Login} />
                            
 

          </Content>
          <Footer style={{ textAlign: 'center' }}>vskdev copyright@ 2020</Footer>
        </Layout>
      </Layout>

      </Router>
    );
  }
}

